import React, { FC } from "react"
import { IMatch, Phase } from "../types"

interface FinishMatchProps{
    match:IMatch | null
}
export const FinishMatch:FC<FinishMatchProps> = ({match}) => {
    if(!match || match.status.phase != Phase.FINISHED) return null;
    return(
        <div className="forecast-finish">
            <p className="forecast-finish_text">Матч был завершен со счетом: {match.homeScore}:{match.awayScore}, {match.oviGoals}+{match.oviHelps}</p>
        </div>
    )
}